// nodemodule imports
import React, {useEffect} from 'react';
import styled from "styled-components";

// project imports
import SideNavigation from "./SideNavigation";
import ApiReference from "./ApiReference";
import {isApiVar} from "../../../cache"

export default ({doc}) => {
  console.log(doc);
  useEffect(() => {
    isApiVar(true);


  })

  return (
    <Wrapper>
      <SideNavigation doc={doc ? doc : 'Introduction'}/>
      <ApiReference doc={doc ? doc : 'Introduction'}/>
    </Wrapper>
  )
}

const Wrapper = styled.div(props => ({

}));
